module.exports = __webpack_public_path__ + "static/media/twitter.81ddbb65.svg";